<template>
  <div class="row mt-5 items-center">
    <div class="col-12">
      <p class="mb-3 font-medium">
        {{ t('customer_centre') }}
      </p>
    </div>
    <div class="col-3 sm:col-2 lg:col-1">
      <ResponsiveImage
        src="default-review-image.png"
        alt="customer centre"
        img-class="footer__person image-cover rounded-circle"
        sizes="10vw"
      />
    </div>
    <div class="col-7 pl-4">
      <a
        :href="`mailto:${t('info_email') + useMailSuffix()}`"
        class="flex items-center py-1 no-decoration text-primary text-nowrap"
      >
        <i class="mi-envelope icon-20 mr-2" />
        {{ t('info_email') + useMailSuffix() }}
      </a>
      <a
        :href="`tel:${t('support_phone_link')}`"
        class="flex items-center py-1 no-decoration text-primary text-nowrap"
      >
        <i class="mi-phone icon-20 mr-2" />
        {{ t('support_phone') }}
      </a>
      <a
        v-if="locale === 'cs' || locale === 'sk'"
        :href="t('whatsapp_link')"
        target="_blank"
        class="flex items-center py-1 no-decoration text-primary text-nowrap"
      >
        <i class="mi-whatsapp icon-20 mr-2" />
        {{ t('whatsapp') }}
      </a>
    </div>
    <div class="col-12 pt-3">
      <p class="m-0 small opacity-50">
        {{ t('working_hours_mo_th') }}<br>
        {{ t('working_hours_fr') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import ResponsiveImage from '@/components/general/BaseImage.vue'
import { useMailSuffix } from "@/mixins/useMailSuffix";

const { t, locale } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "customer_centre": "Zákaznické centrum",
    "info_email": "info",
    "support_phone": "+420 210 012 140",
    "support_phone_link": "+420210012140",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "V pátek 8.00–16.00.",
    "working_hours_mo_th": "Od pondělí do čtvrtka 8.00–16.30."
},
    "sk": {
    "customer_centre": "Zákaznícke centrum",
    "info_email": "info",
    "support_phone": "+421 221 025 208",
    "support_phone_link": "+421221025208",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "V piatok 8.00 - 16.00.",
    "working_hours_mo_th": "Od pondelka do štvrtka 8.00 - 16.30"
},
    "pl": {
    "customer_centre": "Biuro obsługi klienta",
    "info_email": "biuro",
    "support_phone": "(+48) 22 300 17 88",
    "support_phone_link": "(+48)223001788",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Od poniedziałku do piątku 8:00-16:00",
    "working_hours_mo_th": "Od poniedziałku do piątku 8:00-16:00"
},
    "hu": {
    "customer_centre": "Ügyfélszolgálat",
    "info_email": "info",
    "support_phone": "+36 1 550 7665",
    "support_phone_link": "+3615507665",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Pénteken 8:00 - 16:00",
    "working_hours_mo_th": "Hétfőtől - csütörtökig 8:00 - 16:30"
},
    "de": {
    "customer_centre": "Kundenservice",
    "info_email": "Info",
    "support_phone": "+49 221 8461 5111",
    "support_phone_link": "+49 221 8461 5111",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Freitag 7.00 bis 15.00 Uhr",
    "working_hours_mo_th": "Montag bis Freitag 7.00 bis 15.00 Uhr."
},
    "at": {
    "customer_centre": "Kundenservice",
    "info_email": "Info",
    "support_phone": "+49 221 8461 5111",
    "support_phone_link": "+49 221 8461 5111",
    "whatsapp": "WhatsApp",
    "whatsapp_link": "https://wa.me/420725366466",
    "working_hours_fr": "Freitag 7.00 bis 15.00 Uhr",
    "working_hours_mo_th": "Montag bis Freitag 7.00 bis 15.00 Uhr."
},
    "ro": {
    "customer_centre": "Serviciul clienți",
    "info_email": "info",
    "support_phone": "+40 373 761 377",
    "support_phone_link": "+40373761377",
    "whatsapp": "",
    "whatsapp_link": "",
    "working_hours_fr": "",
    "working_hours_mo_th": "Luni - vineri 9:30-15.00"
}
  }
</i18n>
